import React from 'react';
import { AuthRoutes } from '@klpkonsern/auth-core/routes';
import { IconName, Illustration } from '@klp/design/Illustrations';
import {
    Button,
    Divider,
    Icon,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@klp/auth';

export const SidebarUserInfo = () => {
    const { t } = useTranslation();
    const { currentUser } = useCurrentUser();
    return (
        <>
            <Divider />
            <ListItem component="div" dense={true}>
                <ListItemIcon>
                    <Illustration
                        icon={IconName.PROFILE}
                        klpColor="veryLight"
                    />
                </ListItemIcon>
                <ListItemText>
                    {currentUser?.fornavn} {currentUser?.etternavn}
                </ListItemText>
            </ListItem>
            <ListItem component="div" dense={true}>
                <ListItemIcon>
                    <Icon />
                </ListItemIcon>
                <ListItemText>{currentUser?.epost}</ListItemText>
            </ListItem>
            <ListItem component="div" dense={true}>
                <ListItemIcon>
                    <Icon />
                </ListItemIcon>
                <ListItemText>
                    <Button
                        className="Sidebar__StandaloneButton"
                        href={AuthRoutes.logout}
                        startIcon={
                            <Illustration
                                icon={IconName.LOGIN_REQUIRED}
                                klpColor="veryLight"
                            />
                        }
                        variant="outlined"
                    >
                        {t('auth.logout')}
                    </Button>
                </ListItemText>
            </ListItem>
        </>
    );
};
